export default {
    messages: {
        "navbar.links.discover": "ÜBER UBISOFT+",
        "navbar.links.store": "Store",
        "navbar.links.news": "News",
        "navbar.links.forum": "Forum",
        "navbar.links.support": "KUNDENSERVICE",
        "navbar.links.status": "Mein Status",
        "navbar.links.featured": "Highlights",
        "navbar.links.rewards": "Abholen",
        "navbar.links.library": "Alle Spiele",
        "navbar.links.benefits": "UBISOFT+ Belohnungen",
        "navbar.links.subscription": "Mein Abonnement verwalten",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "Alle Spiele",
        "heading.my_games": "Weiterspielen",
        "heading.popular_games": "Beliebteste Spiele",
        "heading.recommended_games": "Empfehlung für dich",
        "action.load_more_games": "Weitere Spiele laden",
        "action.search_for_game": "Spiele durchsuchen nach",
        "action.launch_game": "Spiel starten",
        "action.activate_game": "Spiel aktivieren",
        "filters.brand": "Nach Spielserien sortieren",
        "filters.game_name": "A - Z",
        "filters.release_date": "Erscheinungsdatum",
        "filters.show_all": "Alles anzeigen",
        "filters.sort": "Sortieren nach",
        "filters.all": "Alle",
        "filters.activated": "Aktiviert",
        "message.no_activated_games": "Du verfügst über keine aktivierten Spiele",
        "message.already_owned": "Dieses Spiel besitzt du bereits",
        "message.no_available_games": "Leider nichts Passendes gefunden",
        "message.no_search_results": "Leider nichts Passendes gefunden",
        "message.error": "Ups, da ist ein Fehler aufgetreten",
        "message.refresh_page": "Bitte klicke hier, um es erneut zu versuchen",
        "message.no_subscription": "Du verfügst über kein aktives Abonnement",
        "warning.savefiles_alert.title": "Eine wichtige Info zu deinen Speicherständen.",
        "warning.savefiles_alert.body": "Mit dem Upgrade auf die in UBISOFT+ verfügbare (ggfs. umfangreichere) Version des Spiels, kann es zu Problemen mit deinen aktuellen Speicherständen im Spiel kommen. Wenn dein UBISOFT+ Abo endet, kann es nötig sein, dass du den Season Pass erwibst, um deinen Spielfortschritt (auch den älteren) wieder nutzen zu können. Für weitere Informationen lies bitte unsere Artikel {here}.",
        "warning.savefiles_alert.body.here": "hier",
        "warning.savefiles_alert.cancel": "Zurück",
        "warning.savefiles_alert.confirm": "Bestätigen",
        "warning.mobile_launch_alert.body": "{game} wurde deiner Spielebibliothek hinzugefügt. Über die Uplay-App hast du Zugriff auf deine Spiele.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "NUTZUNGSBEDINGUNGEN",
        "footer.links.privacy_policy_label": "DATENSCHUTZRICHTLINIE",
        "footer.links.legal_label": "IMPRESSUM",
        "hero.title": "Ubisoft Abonnement-Service",
        "hero.subtitle": "UNBEGRENZTER ZUGANG ZU ÜBER 100 SPIELEN | JEDERZEIT KÜNDBAR",
        "hero.buttons.subscribe": "Jetzt abonnieren",
        "hero.buttons.login": "Anmeldung",
        "hero.buttons.browse": "Alle Spiele ansehen",
        "progression.benefits.description": "Schalte unsere Welten frei und erobere deine eigenen. Wir möchten deine Treue belohnen!  Erhalte jeden Monat neue Ingame-Gegenstände.\r\nJe länger du bei Ubisoft+ bist, desto mehr Ingame-Belohnungen bekommst du!",
        "progression.benefit.singular.reward": "Belohnung",
        "progression.benefit.plural.reward": "Belohnungen",
        "progression.benefit.singular.benefit": "Rabatt-Vorteil",
        "progression.benefit.plural.benefit": "Rabatt-Vorteile",
        "progression.benefit.singular.booster": "Boost",
        "progression.benefit.plural.booster": "Boosts",
        "progression.level.subscribed_for": "Laufzeit des Abonnements",
        "progression.level.new_subscriber": "Neuer Abonnent",
        "progression.level.new_subscribers": "Neue Abonnenten",
        "progression.level.subscription.first_month": "1. Monat",
        "progression.level.subscription.starting_with_months": "{months}+ Monate",
        "general.date.month": "monat",
        "general.date.months": "monate",
        "general.date.month_remaining": "verbleibender Monat",
        "general.date.months_remaining": "verbleibende Monate",
        "rewards.monthly_rewards": "Deine monatlichen Belohnungen",
        "rewards.trial_info": "Free trial",
        "rewards.left": "{time_left} übrig, um {rewards_left} Belohnung(en) in diesem Monat freizuschalten",
        "rewards.current_title": "Belohnungen des Monats",
        "rewards.previous_title": "Deine letzten Belohnungen",
        "rewards.upcoming_title": "Bevorstehende Belohnungen",
        "rewards.none_found": "Keine Belohnung gefunden",
        "rewards.available": "Verfügbar",
        "rewards.locked": "Gesperrt",
        "rewards.claimed": "Abgeholt",
        "rewards.claim": "Jetzt abholen",
        "rewards.cancel": "Abbrechen",
        "rewards.confirm": "Möchtest du die Belohnung jetzt abholen?",
        "rewards.none_left": "Es stehen keine Belohnungen zur Abholung bereit",
        "rewards.already_claimed": "Diese Belohnung hast du bereits abgeholt",
        "rewards.claim_confirm": "Diese Belohnung ist jetzt in Ihrem Spiel verfügbar",
        "rewards.close": "Verstanden!",
        "rewards.load_more": "Mehr laden",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "More Info",
        "external.links.actions.learn_more": "Learn More"
    }
};